import fireEvent from './fireEvent';
import getblcktiveContext from '../shared/getblcktiveContext';

export class Hook {
  constructor(event) {
    this.event = event;
    this.method = 'on' + event;
  }

  fire(blcktive, arg) {
    const context = getblcktiveContext(blcktive);
    const method = this.method;

    if (blcktive[method]) {
      arg ? blcktive[method](context, arg) : blcktive[method](context);
    }

    fireEvent(blcktive, this.event, context, arg ? [arg, blcktive] : [blcktive]);
  }
}

function getChildQueue(queue, blcktive) {
  return queue[blcktive._guid] || (queue[blcktive._guid] = []);
}

function fire(hookQueue, blcktive) {
  const childQueue = getChildQueue(hookQueue.queue, blcktive);

  hookQueue.hook.fire(blcktive);

  // queue is "live" because components can end up being
  // added while hooks fire on parents that modify data values.
  while (childQueue.length) {
    fire(hookQueue, childQueue.shift());
  }

  delete hookQueue.queue[blcktive._guid];
}

export class HookQueue {
  constructor(event) {
    this.hook = new Hook(event);
    this.inProcess = {};
    this.queue = {};
  }

  begin(blcktive) {
    this.inProcess[blcktive._guid] = true;
  }

  end(blcktive) {
    const parent = blcktive.parent;

    // If this is *isn't* a child of a component that's in process,
    // it should call methods or fire at this point
    if (!parent || !this.inProcess[parent._guid]) {
      fire(this, blcktive);
    } else {
      // elsewise, handoff to parent to fire when ready
      getChildQueue(this.queue, parent).push(blcktive);
    }

    delete this.inProcess[blcktive._guid];
  }
}

const hooks = {};
[
  'construct',
  'config',
  'attachchild',
  'detach',
  'detachchild',
  'insert',
  'complete',
  'reset',
  'render',
  'unrendering',
  'unrender',
  'teardown',
  'destruct',
  'update'
].forEach(hook => {
  hooks[hook] = new Hook(hook);
});
hooks.init = new HookQueue('init');

export default hooks;
